<section class="auth-page">
  <div class="auth-card ecb-card register-card">
    <div class="auth-visual">
      <a routerLink="/" class="ecb-logo"><span class="ecb-logo-mark">ECB</span><span
          class="ecb-logo-text"><span>ECB</span><small>TRAINING SERVICES</small></span></a>
      <h1>Create Student Account</h1>
      <p>Register once and use your account for bookings, payments and certificates.</p>
      <div class="auth-badge"><i class="fa fa-shield"></i><span>Protected student enrolment</span></div>
    </div>
    <div class="auth-form">
      <h2>Register</h2>
      <p class="ecb-muted">Enter your details to continue with booking.</p>
      <div class="row g-3">
        <div class="col-md-6"><label>First Name</label><input class="ecb-form-control" [(ngModel)]="model.firstName">
        </div>
        <div class="col-md-6"><label>Last Name</label><input class="ecb-form-control" [(ngModel)]="model.lastName">
        </div>
        <div class="col-12"><label>Email</label><input class="ecb-form-control" [(ngModel)]="model.email"></div>
        <div class="col-12"><label>Mobile Number</label><input class="ecb-form-control" [(ngModel)]="model.mobileNo">
        </div>
        <div class="col-12"><label>Password</label><input class="ecb-form-control" type="password"
            [(ngModel)]="model.password"></div>
      </div>
      <button class="ecb-btn-primary w-100 mt-3" (click)="register()"><i class="fa fa-user-plus"></i> Create
        Account</button>
      <a routerLink="/auth/customer-login" class="register-link">Already have an account?</a>
    </div>
  </div>
</section>